/**
 * Parse a money amount the way a human typed it — German ("1.997,50"),
 * English ("1,997.50"), or plain ("1997.5" / "1997"). Rules:
 *   - both separators present → the LAST one is the decimal separator
 *   - only comma → decimal separator (German default), unless it appears
 *     multiple times (then thousands)
 *   - only dot → decimal separator, unless it appears multiple times or is
 *     followed by exactly 3 digits ("1.997" → 1997, thousands)
 * The Add-Event dialog shows a live preview of the parsed value, so
 * ambiguous input is always visible to the operator before submitting.
 */
export function parseDealValue(raw: string): number | null {
  let s = raw
    .trim()
    .replace(/[€\s]/g, "")
    .replace(/[a-zA-Z]/g, "");
  if (!s) return null;
  const hasComma = s.includes(",");
  const hasDot = s.includes(".");
  if (hasComma && hasDot) {
    if (s.lastIndexOf(",") > s.lastIndexOf(".")) {
      s = s.replace(/\./g, "").replace(",", ".");
    } else {
      s = s.replace(/,/g, "");
    }
  } else if (hasComma) {
    const parts = s.split(",");
    s = parts.length > 2 ? s.replace(/,/g, "") : s.replace(",", ".");
  } else if (hasDot) {
    const parts = s.split(".");
    if (parts.length > 2 || parts[1]?.length === 3) {
      s = s.replace(/\./g, "");
    }
  }
  const n = Number(s);
  return Number.isFinite(n) ? n : null;
}
